import { FACETS } from '../config/facets';
import { RESET_FILTERS, SET_FACET_VALUE, SET_PAGE, SYNC_FACET_VALUE } from '../actions/searchAction';

export const searchInitialState = {
  facets: {
    [FACETS.AUDIENCE]: null,
    [FACETS.INTEREST]: null,
    [FACETS.SEASON]: null,
  },
  page: 0,
}

const searchReducer = (state = searchInitialState, { type, payload }) => {
  switch (type) {
    case SET_FACET_VALUE:
      return {
        facets: {
          ...state.facets,
          ...payload
        },
        page: 0,
      }
    case SET_PAGE:
      return { ...state, page: payload }
    case SYNC_FACET_VALUE:
      return { ...state, ...payload }
    case RESET_FILTERS:
      return {
        facets: {
          [FACETS.AUDIENCE]: null,
          [FACETS.INTEREST]: null,
          [FACETS.SEASON]: null,
        },
        page: 0,
      }
    default:
      return state;
  }
};

export default searchReducer;
